import { fsdb } from '../firebase'
import {
  canAccess,
  collection,
  doc,
  listReadableForAccount,
  listReadableForAccountAndUser,
  listReadableForUser,
  WRITE_ACCESS
} from './common'
import { asRecordId, composeQuery, getRootCollection } from './queries'

export const VAULT_STAGE = 'Vault'
export const CREATED_STAGE = 'CREATED'

export const listDocuments = () => getRootCollection('documents')

const whereVaulted = (query) => query.where('stage', '==', 'Vault')
const whereNotDeleted = (query) => query.where('deleted', '==', false)
const whereUnvaulted = (query) => query.where('stage', '!=', VAULT_STAGE)

export const listDashboardDocuments = () =>
  composeQuery(listDocuments, whereUnvaulted, whereNotDeleted)

export const listVaultDocumentsForAccount = listReadableForAccount(
  listDocuments,
  whereVaulted
)

export const canWriteDocument = (...options) =>
  canAccess(WRITE_ACCESS, ...options)

export const listDashboardDocumentsForUser = listReadableForUser(
  listDashboardDocuments
)

export const listDashboardDocumentsForAccountAdmin =
  listReadableForAccountAndUser(listDashboardDocuments)

const content = collection('content')

const getContentCollectionDoc = (document, contentCollectionDoc) =>
  composeQuery(
    listDocuments,
    doc(asRecordId(document)),
    content,
    doc(asRecordId(contentCollectionDoc))
  )

export const getDocumentRef = (document) =>
  composeQuery(listDocuments, doc(asRecordId(document)))

export const getContentAssetData = (document) =>
  getContentCollectionDoc(document, 'assetData')

export const getContentData = (document) =>
  getContentCollectionDoc(document, 'data')

export const updateContentAssetData = async (document, data, metadata) => {
  const batch = fsdb.batch()
  batch.set(getContentAssetData(document), data)
  batch.update(document, metadata)
  await batch.commit()
}
